import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";

const api = new APIClient();

export type ExtensionBinding = {
  id?: number;
  unit_id: number;
  phone_digits: string;
  is_default: boolean;
};

export type ExtensionConfig = {
  extension_enabled: boolean;
  bindings: ExtensionBinding[];
};

/**
 * ID estável da Chrome Web Store (unlisted).
 * Redirect OAuth: `https://{id}.chromiumapp.org/` — ver `chrome-extension/STORE.md`.
 */
export const CHROME_EXTENSION_ID = "bhhadmhojgjibfjkbjmpahcgpfkmibpl";

/** URL pública da listagem (fallback se o build não tiver env). */
export const CHROME_WEB_STORE_URL_DEFAULT =
  `https://chromewebstore.google.com/detail/${CHROME_EXTENSION_ID}`;

/**
 * URL unlisted da Chrome Web Store.
 * Preferir `REACT_APP_CHROME_EXTENSION_STORE_URL` no build; ver `chrome-extension/STORE.md`.
 */
export const CHROME_WEB_STORE_URL: string = (() => {
  const fromEnv = (process.env.REACT_APP_CHROME_EXTENSION_STORE_URL || "").trim();
  return fromEnv !== "" ? fromEnv : CHROME_WEB_STORE_URL_DEFAULT;
})();

/** Piloto / debug: load unpacked (devs). Produção usa `CHROME_WEB_STORE_URL`. */
export const CHROME_EXTENSION_INSTALL_HINT =
  "chrome://extensions → Modo do desenvolvedor → Carregar sem compactação → pasta chrome-extension/";

export const getExtensionConfig = () =>
  api.get<ApiResponse<ExtensionConfig>>("/extension/config");

export const updateExtensionConfig = (payload: {
  extension_enabled?: boolean;
  bindings?: Array<{
    unit_id: number;
    phone_digits: string;
    is_default?: boolean;
  }>;
}) => api.put<ApiResponse<ExtensionConfig>>("/extension/config", payload);
